import { memo, useEffect, useState } from 'react'
import DatePicker from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import 'react-multi-date-picker/styles/colors/teal.css'
import transition from 'react-element-popper/animations/transition'
import opacity from 'react-element-popper/animations/opacity'
import DateObject from 'react-date-object'
import gregorian from 'react-date-object/calendars/gregorian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import { useTodayPersian } from '../../hooks/useTodayPersian'

function RangeDatePickerInput({ setPeriod }) {
  const [today] = useTodayPersian()
  const [values, setValues] = useState([])

  useEffect(() => {
    if (values?.length === 1) {
      setPeriod([new DateObject(values[0]).convert(gregorian, gregorian_en).format(), null])
    } else if (values?.length === 2) {
      setPeriod([
        new DateObject(values[0]).convert(gregorian, gregorian_en).format(),
        new DateObject(values[1]).convert(gregorian, gregorian_en).format(),
      ])
    }
  }, [values])

  return (
    <>
      <div className="dv-datepicker" style={{ direction: 'rtl' }}>
        <DatePicker
          inputClass={`${values?.length === 1 ? 'w-32' : values?.length === 2 ? 'w-fit' : 'w-36'}
                    h-11 bg-white dark:bg-slate-800 text-center border border-gray-300 dark:border-slate-500 py-3 px-4 cursor-pointer outline-0
                    rounded-lg text-sm font-semibold text-gray-800 dark:text-amber-100 placeholder:text-gray-500`}
          calendar={persian}
          locale={persian_fa}
          value={values}
          maxDate={today}
          onChange={setValues}
          range
          rangeHover
          calendarPosition="top-center"
          animations={[opacity(), transition({ from: 35, duration: 800 })]}
          placeholder="انتخاب تاریخ ها"
        />
      </div>
    </>
  )
}

export default memo(RangeDatePickerInput)
